import Cookies from 'js-cookie';

export const APP_BASE_URL = 'https://api.cbcs.atlasrnd.group';
// export const AUTH_BASE_URL = 'https://api.auth.cbcs.atlasrnd.group';
export const AUTH_BASE_URL = 'http://127.0.0.1:5566';
export const IMAGE_BASE_URL = '';
export const VIDEO_BASE_URL = '';

export const getUsername = () => {
  return Cookies.get('username');
};
